import api from '@/api';

const state = {
    contractItems: [],
};

const mutations = {
    setContractItems(state, contractItems) {
        state.contractItems = contractItems;
    },
};

const actions = {
    async loadContractItems({ commit }) {
        const response = await api.contractItems.list();
        commit('setContractItems', response.data);
    },
};

const getters = {
    contractItems(state) {
        return state.contractItems || [];
    },
    contractItemsValueText(_, getters) {
        return getters.contractItems.map(item => ({
            value: item.id,
            text: item.description,
            contractId: item.contract.id,
        }));
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/contractItems.js